import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const previewId = () => {
  try { return new URLSearchParams(window.location.search).get("preview") || ""; } catch { return ""; }
};

/* Contenido editable del sitio (textos/colores/imágenes gestionados desde el adminpanel / IA).
   get(key, fallback) devuelve el valor personalizado o el texto original del código. */
export const useSiteContent = () => {
  const pid = previewId();
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ["site-content", pid],
    queryFn: async () => {
      const t = localStorage.getItem("ca_token");
      const headers = pid && t ? { Authorization: `Bearer ${t}` } : {};
      return (await axios.get(`${API}/site-content/public${pid ? `?preview=${encodeURIComponent(pid)}` : ""}`, { headers })).data;
    },
    staleTime: 60_000,
    retry: 1,
  });
  const custom = data?.custom || {};

  useEffect(() => {
    const root = document.documentElement;
    if (custom["theme.accent"]) root.style.setProperty("--site-accent", custom["theme.accent"]);
    else root.style.removeProperty("--site-accent");
    if (custom["theme.background"]) root.style.setProperty("--site-bg", custom["theme.background"]);
    else root.style.removeProperty("--site-bg");
  }, [custom]);

  useEffect(() => {
    const onChange = () => qc.invalidateQueries({ queryKey: ["site-content"] });
    window.addEventListener("ca:site-content-changed", onChange);
    return () => window.removeEventListener("ca:site-content-changed", onChange);
  }, [qc]);

  return {
    get: (key, fallback) => (custom[key] !== undefined && custom[key] !== "" ? custom[key] : fallback),
    custom,
    isPreview: !!data?.preview,
    previewId: pid,
  };
};

export default useSiteContent;
